import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

import Grid from "./layouts/Grid";
import Accordion from "./layouts/Accordion";

const layouts = {
  'grid': Grid,
  'accordion': Accordion
}

export const Solution = ({
  settings,
  blocks 
}) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layout = isMobile ? 'accordion' : 'grid';

  const LayoutComponent = layouts[layout] || Grid;
  return (
    <>
      <LayoutComponent
          settings={settings}
          blocks={blocks}
      />
    </>
  );
};

export default Solution;